import { gql } from 'apollo-angular';

export const CREATE_CHART_ACCOUNTS = gql`
  mutation createAccount($createAccountInput:CreateAccountInput!) {
    createAccount(createAccountInput: $createAccountInput) {
      id
      accountName
      accountCode
    }
  }
`;

export const REMOVE_CHART_ACCOUNTS = gql`
  mutation removeAccount($id: Int!) {
    removeAccount(id: $id)
  }
`;

export const UPDATE_CHART_ACCOUNTS = gql`
  mutation updateAccount($updateAccountInput:UpdateAccountInput!) {
    updateAccount(updateAccountInput: $updateAccountInput) {
      id
      accountName
      accountCode
    }
  }
`;
